import { REPORTS_API } from "redux/api";

const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if(payload?.tablePageNo){
        query+="&page="+payload?.tablePageNo
    }else if(payload?.page){
        query+="&page="+payload?.page
    }
    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.type){
        query+=`&type=${payload?.type}`
    }
    return "?"+query?.slice(1)
}

export const getTodaysReservationOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/today-reservation/overview${query}`,
    });
};

export const getTodaysReservationVolumeBySession = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/todays-reservation/volume-by-session${query}`,
    });
};

export const getTodaysAssignedReservation = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/today-reservation/seated-details${query}`,
    });
};

export const getTodaysUpcomingReservation = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/today-reservation/assigned-details${query}`,
    });
};

export const getUpcomingReservationOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/overview${query}`,
    });
};

export const getUpcomingReservationVolumeBySession = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/volume-by-session${query}`,
    });
};

export const getUpcomingReservationVolume = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/volume${query}`,
    });
};

export const getUpcomingReservationBySession = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/by-session${query}`,
    });
};

export const getUpcomingReservationStatusByDate = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/status-by-date${query}`,
    });
};

export const getUpcomingReservationCancellationByReasons = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/cancellation-reason${query}`,
    });
};

export const getUpcomingReservationDetails = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/upcoming-reservation/details${query}`,
    });
};


export const getReservationOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/totals${query}`,
    });
};

export const getReservationOverviewSlotWiseReservation = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/overview/slot-wise-reservation${query}`,
    });
};

export const getReservationOverviewDailyReservationsGuests = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/daily-reservation-and-guests${query}`,
    });
};

export const getReservationOverviewDineInDurationByGroups = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/dine-in-duration${query}`,
    });
};

export const getReservationOverviewGuestSizeDistribution = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/guest-size-distribution${query}`,
    });
};

export const getReservationOverviewDetails = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/overview-details${query}`,
    });
};

export const getReservationTrendOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/trend/overview${query}`,
    });
};

export const getReservationTrend = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/trend${query}`,
    });
};

export const getReservationTrendByGroups = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/trend/by-groups${query}`,
    });
};

export const getReservationTrendByAvgWaitTime = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/trend/by-avg-wait-time${query}`,
    });
};

export const getReservationTrendCustomerTrend = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/trend/customer-trend${query}`,
    });
};

export const getReservationTrendCustomerVisits = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/reservations/overview-reservations/trend/customer-visits${query}`,
    });
};
